// src/blocks/slideshow/view.js
import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import { openLightbox } from '../../js/lightbox-manager';

document.addEventListener('DOMContentLoaded', () => {
    const slideshows = document.querySelectorAll('.clhb-custom-slideshow-wrapper');

    slideshows.forEach((container) => {
        const swiperEl = container.querySelector('.swiper');
        const slidesPerViewDesktop = 2;
        const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

        const canLoop = slidesCount > 4;

        if (swiperEl) {
            new Swiper(swiperEl, {
                modules: [Navigation, Keyboard],
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
                loop: canLoop,
                keyboard: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: slidesPerViewDesktop,
                        spaceBetween: 10,
                    },
                },
            });

            // Ecouteur de clic spécifique à ce slider
            swiperEl.addEventListener('click', (e) => {
                if (window.innerWidth < 1024) return;

                const slide = e.target.closest('.swiper-slide');
                if (!slide) return;
                if (!slide.classList.contains('swiper-slide-active')) return;

                const allSlides = Array.from(swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
                const slideIndex = allSlides.indexOf(slide);

                // 1. Clonage du Swiper original
                const swiperClone = swiperEl.cloneNode(true);

                // 2. Restructuration sémantique de chaque slide du clone
                const cloneSlides = swiperClone.querySelectorAll('.swiper-slide');
                cloneSlides.forEach((cloneSlide) => {
                    const img = cloneSlide.querySelector('img');
                    if (!img) return;

                    // Récupération du texte alternatif (ou fallback si vide)
                    const altText = img.getAttribute('alt') ? img.getAttribute('alt').trim() : '';

                    // On crée la structure demandée
                    const container = document.createElement('div');
                    container.classList.add('lightbox-slide-container');

                    const figure = document.createElement('figure');

                    // On clone l'image existante pour la déplacer dans la figure
                    const imgClone = img.cloneNode(true);

                    // On assemble le container et la figure
                    figure.appendChild(imgClone);

                    // Si un texte alternatif existe, on crée et injecte le figcaption
                    if (altText !== '') {
                        const figcaption = document.createElement('figcaption');
                        figcaption.classList.add('lightbox-caption');
                        figcaption.textContent = altText;
                        figure.appendChild(figcaption);
                    }

                    container.appendChild(figure);

                    // 3. On vide le contenu actuel de la slide du clone et on y injecte notre nouvelle structure
                    cloneSlide.innerHTML = '';
                    cloneSlide.appendChild(container);
                });

                // 4. Ouverture de la lightbox avec notre clone restructuré
                openLightbox(swiperClone);

                // Initialisation du Swiper dans la Lightbox
                setTimeout(() => {
                    new Swiper(swiperClone, {
                        modules: [Navigation, Keyboard],
                        slidesPerView: 1,
                        initialSlide: slideIndex,
                        spaceBetween: 0,
                        centeredSlides: true,
                        loop: slidesCount >= 2,
                        rewind: slidesCount < 2,
                        keyboard: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        on: {
                            init: function () {
                                swiperClone.classList.add('is-ready');
                            },
                        },
                    });
                }, 50);

            });
        }
    });
});
